import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import WaveSurfer from 'wavesurfer.js'
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-waveform-audio-player',
  templateUrl: './waveform-audio-player.component.html',
  styleUrls: ['./waveform-audio-player.component.css']
})
export class WaveformAudioPlayerComponent implements OnInit {

  @Input() src: string;
  @Input() blob?: Blob;
  @Input() showClearButton: boolean = false;
  @Input() backgroundColor: string = '#28292b';
  @Input() waveColor: string = '#a0a0a0';
  @Input() progressColor: string = '#ffffff';
  @Input() height: number = 36;
  @Input() disabled: boolean = false;

  @Output() onClear = new EventEmitter();

  wavesurfer: WaveSurfer;

  constructor(
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.setupWaveSurver();
  }

  setupWaveSurver() {
    this.wavesurfer?.destroy();
    this.wavesurfer = WaveSurfer.create({
      container: '#waveform',
      waveColor: this.waveColor,
      progressColor: this.progressColor,
      height: this.height,
      dragToSeek: true,
      url: !this.blob ? this.src : undefined
    });
    if (this.blob) this.wavesurfer.loadBlob(this.blob);

    this.wavesurfer.on('error', (error: Error) => {
      console.log(error);
    });

    this.wavesurfer.on('finish', () => {
      this.wavesurfer.pause();
      this.wavesurfer.setTime(0);
    });
  }

  togglePlay() {
    if (!this.wavesurfer) return;
    this.wavesurfer.playPause();
  }

  onClearPressed() {
    this.onClear.emit();
  }

}
